<!-- PAN validation -->
<div pmdModal
    modalTrap
    #panModal="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="PANValidation"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header m-0 position-absolute end-0"
                style="z-index: 9999;">
                <button aria-label="Close"
                    (keyup)="panModal.hide()"
                    (click)="panModal.hide()"
                    class="ms-auto close"
                    type="button"><i class="material-icons-round">close</i></button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-3 pmd-avatar pmd-avatar-dark pmd-avatar-xl d-inline-flex"
                    aria-hidden="true">
                    <span class="material-icons">save</span>
                </div>
                <h4 class="h5">
                    PAN is {{ context.seller?.pan?.value ? 'invalid' : 'mandatory' }}
                </h4>
                <p>Valid PAN is mandatory. Please provide valid PAN.</p>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-center mt-2">
                <button aria-label="Close"
                    (click)="panModal.hide(); context.panRef?.nativeElement?.focus();"
                    pmdRipple
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="light">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
<!-- /END/ PAN validation -->

<!-- confirm submit -->
<div pmdModal
    modalTrap
    #submitModal="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="SubmitReview"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header m-0 position-absolute end-0"
                style="z-index: 9999;">
                <button aria-label="Close"
                    (click)="submitModal.hide()"
                    class="ms-auto close"
                    type="button"><i class="material-icons-round">close</i></button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-3 pmd-avatar pmd-avatar-dark pmd-avatar-xl d-inline-flex"
                    aria-hidden="true">
                    <span class="material-icons">save</span>
                </div>
                <h4 class="h5">
                    The invoice is not saved yet!
                </h4>
                <p>This invoice contains some erroneous data.<br /> Do you still want to save?</p>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-center mt-2">
                <button aria-label="Close"
                    (click)="context.review(false, context.isInvoiceMarked)"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    pmdRipple>
                    Save
                </button>
                <button aria-label="Close"
                    (click)="submitModal.hide()"
                    pmdRipple
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="light">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
<!-- /END/ confirm submit -->

<!-- Reject Invoice -->
<div pmdModal
    modalTrap
    #RejectInvoice="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="RejectLabel"
    (onHide)="context.selectExistingRejectionReason()"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header pb-3 border-b-1 align-items-center"
                style="z-index: 9999;">
                <h4 class="modal-title">Help us know your reason for rejection</h4>
                <button aria-label="Close"
                    (click)="RejectInvoice.hide()"
                    class="ms-auto close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body">
                <pmd-form-group class="mb-3">
                    <ng-select id="reason"
                        class="pmd-select pmd-select-outline"
                        appearance="outline"
                        [clearable]="context.selectedReasonId ? true : false"
                        [searchable]="false"
                        placeholder="Select reason *"
                        [(ngModel)]="context.selectedReasonId">
                        <ng-option *ngFor="let reason of context.rejectionReasons"
                            [value]="reason.id">{{ reason.name }}</ng-option>
                    </ng-select>
                </pmd-form-group>
                <div [ngClass]="context.otherReason ? 'pmd-textfield-floating-label-completed mb-3' : 'mb-3'">
                    <label for="other-reason"
                        class="control-label mb-1">
                        Tell us more
                    </label>
                    <textarea id="other-reason"
                        type="text"
                        class="form-control"
                        [(ngModel)]="context.otherReason"
                        aria-label="type your message">
                </textarea>
                </div>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-start mt-2">
                <button aria-label="Close"
                    (click)="context.reject(RejectInvoice)"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    [disabled]="!context.selectedReasonId"
                    [attr.aria-disabled]="!context.selectedReasonId"
                    pmdRipple>
                    Submit
                </button>
                <button aria-label="Close"
                    (click)="RejectInvoice.hide()"
                    pmdRipple
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="light">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
<!-- /END/ Reject Invoice -->

<!-- Save as Draft Reason -->
<div pmdModal
    modalTrap
    #draftReasonPopup="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="RejectLabel"
    (onHide)="context.selectExistingRejectionReason()"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header pb-3 border-b-1 align-items-center"
                style="z-index: 9999;">
                <h4 class="modal-title">Please select reason to Save as draft</h4>
                <button aria-label="Close"
                    (click)="context.hideDraftReasonModal(draftReasonPopup)"
                    class="ms-auto close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body">
                <pmd-form-group class="mb-3">
                    <ng-select id="reason"
                        class="pmd-select pmd-select-outline"
                        appearance="outline"
                        [clearable]="context.selectedSaveAsDraftReasonId ? true : false"
                        [searchable]="false"
                        placeholder="Select reason *"
                        [(ngModel)]="context.selectedSaveAsDraftReasonId"
                        (ngModelChange)="context.onDraftReasonChange($event)">
                        <ng-option *ngFor="let reason of context.draftReasons"
                            [value]="reason.id">{{ reason.name }}</ng-option>
                    </ng-select>
                </pmd-form-group>
                <div *ngIf="context.selectedSaveAsDraftReasonId === context.otherDraftReasonId"
                    [ngClass]="context.draftOtherRemark ? 'pmd-textfield-floating-label-completed mb-3' : 'mb-3'">
                    <label for="draft-other-remark"
                        class="control-label mb-1">
                        Remark *
                    </label>
                    <textarea id="draft-other-remark"
                        rows="3"
                        maxlength="500"
                        class="form-control"
                        placeholder="Enter the reason for saving as draft"
                        [(ngModel)]="context.draftOtherRemark"
                        aria-label="Enter the reason for saving as draft"></textarea>
                </div>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-start mt-2">
                <button aria-label="Close"
                    (click)="context.submitSaveAsDraftReason(draftReasonPopup)"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    [disabled]="!context.canSubmitDraftReason"
                    [attr.aria-disabled]="!context.canSubmitDraftReason"
                    pmdRipple>
                    Submit
                </button>
                <button aria-label="Close"
                    (click)="context.hideDraftReasonModal(draftReasonPopup)"
                    pmdRipple
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="light">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
<!-- End of Save as Draft Reason -->

<!-- Duplicate invoice -->
<div pmdModal
    modalTrap
    #duplicateModal="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="DeleteLabel"
    aria-hidden="true"
    (onHide)="context.onDuplicateModalHide()">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header pb-3 border-b-1 align-items-center"
                style="z-index: 9999;">
                <h4 class="modal-title">Mark invoice as duplicate</h4>
                <button aria-hidden="true"
                    aria-label="Close"
                    (click)="duplicateModal.hide()"
                    class="ms-auto close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body text-center">
                <label>
                    Are you sure you want to mark this invoice as a duplicate?
                </label>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-start mt-2">
                <button type="button"
                    aria-label="Close"
                    (click)="context.review(true, true); duplicateModal.hide();"
                    pmdRipple
                    pmd-btn-raised
                    color="secondary">
                    Mark Duplicate
                </button>
                <button type="button"
                    aria-label="Close"
                    (click)="context.review(true, false); duplicateModal.hide();"
                    pmd-btn-outline
                    pmdRipple
                    color="dark">
                    Ignore
                </button>
            </div>
        </div>
    </div>
</div>
<!-- /END/ Duplicate invoice -->

<!-- Confirm Delete Credit Note entries Modal -->
<div pmdModal
    modalTrap
    #deleteCreditEntriesModal="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="DeleteLabel"
    aria-hidden="true"
    (onHide)="context.setOriginalCompany()">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header m-0 position-absolute end-0"
                style="z-index: 9999;">
                <button aria-hidden="true"
                    aria-label="Close"
                    (click)="deleteCreditEntriesModal.hide()"
                    class="ms-auto close"
                    type="button"><i class="material-icons-round">close</i></button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-3 pmd-avatar pmd-avatar-danger pmd-avatar-xl d-inline-flex"
                    aria-hidden="true">
                    <span class="material-icons">info</span>
                </div>
                <h4 id="DeleteLabel"
                    class="h5">
                    All the linked Invoices on the Invoice Review page will be removed in case of the change in
                    Supplier name.
                </h4>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-center mt-2">
                <button type="button"
                    aria-label="Close"
                    (click)="context.onDeleteCreditNoteEntries(); context.autoSaveInvoice();"
                    pmdRipple
                    pmd-btn-raised
                    color="secondary">
                    Yes
                </button>
                <button type="button"
                    aria-label="Close"
                    (click)="deleteCreditEntriesModal.hide(); context.setOriginalCompany(); context.autoSaveInvoice();"
                    pmd-btn-outline
                    pmdRipple
                    color="dark">
                    No
                </button>
            </div>
        </div>
    </div>
</div>
<!-- /END/ Confirm Delete Credit Note entries Modal -->

<!-- AI Save & Exit Modal -->
<div pmdModal
    modalTrap
    #mergeConfirmation="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="RejectLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header pb-3 border-b-1 align-items-center"
                style="z-index: 9999;">
                <h4 class="modal-title">Accept & Merge AI Results?</h4>
                <button aria-label="Close"
                    (click)="mergeConfirmation.hide()"
                    class="ms-auto close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body">
                <p>This action will merge AI result in to Product Table. </p>
                <p>Do you wish to proceed? This action can't be undone.</p>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-start mt-2">
                <button aria-label="Close"
                    (click)="mergeConfirmation.hide()"
                    pmdRipple
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="light">
                    Cancel
                </button>
                <button aria-label="Close"
                    (click)="mergeConfirmation.hide(); context.onSaveAndExitAIMode()"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    pmdRipple>
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>
<!-- END of AI Save & Exit -->

<!-- confirm leave anyway / save as draft -->
<div pmdModal
    modalTrap
    #unsavedChangesModal="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="unsavedChangesModal"
    (onHide)="context.clearSaveAsDraftReason()"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header m-0 position-absolute end-0"
                style="z-index: 9999;">
                <button aria-label="Close"
                    (click)="context.isSaveAsDraftAndLeave = false; context.clearSaveAsDraftReason(); unsavedChangesModal.hide()"
                    class="ms-auto close"
                    type="button"><i class="material-icons-round">close</i></button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-3 pmd-avatar pmd-avatar-dark pmd-avatar-xl d-inline-flex"
                    aria-hidden="true">
                    <span class="material-icons">warning</span>
                </div>
                <h4 class="h5">
                    Unsaved Changes!
                </h4>
                <p>The changes you made will not be saved. <br /> Either save it as a draft or leave anyway.</p>
                <pmd-form-group class="mb-3 text-start">
                    <ng-select id="reason"
                        class="pmd-select pmd-select-outline"
                        appearance="outline"
                        [clearable]="context.selectedSaveAsDraftReasonId ? true : false"
                        [searchable]="false"
                        placeholder="Select reason to save as draft *"
                        [(ngModel)]="context.selectedSaveAsDraftReasonId"
                        (ngModelChange)="context.onDraftReasonChange($event)">
                        <ng-option *ngFor="let reason of context.draftReasons"
                            [value]="reason.id">{{ reason.name }}</ng-option>
                    </ng-select>
                </pmd-form-group>
                <div *ngIf="context.selectedSaveAsDraftReasonId === context.otherDraftReasonId"
                    class="text-start"
                    [ngClass]="context.draftOtherRemark ? 'pmd-textfield-floating-label-completed mb-3' : 'mb-3'">
                    <label for="unsaved-draft-other-remark"
                        class="control-label mb-1">
                        Remark *
                    </label>
                    <textarea id="unsaved-draft-other-remark"
                        rows="3"
                        maxlength="500"
                        class="form-control"
                        placeholder="Enter the reason for saving as draft"
                        [(ngModel)]="context.draftOtherRemark"
                        aria-label="Enter the reason for saving as draft"></textarea>
                </div>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-center mt-2">
                <button aria-label="Close"
                    (click)="context.onSaveAsDraftAndLeave()"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    [disabled]="!context.canSubmitDraftReason"
                    [attr.aria-disabled]="!context.canSubmitDraftReason"
                    pmdRipple>
                    Save as Draft
                </button>
                <button aria-label="Close"
                    (click)="context.onLeaveWithoutSaving()"
                    pmdRipple
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="light">
                    Leave
                </button>
            </div>
        </div>
    </div>
</div>
<!-- /END/ confirm leave anyway / save as draft -->

<!-- confirm delete all products -->
<div pmdModal
    modalTrap
    #deleteAllProducts="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="SubmitReview"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header m-0 position-absolute end-0"
                style="z-index: 9999;">
                <button aria-label="Close"
                    (click)="deleteAllProducts.hide()"
                    class="ms-auto close"
                    type="button"><i class="material-icons-round">close</i></button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-3 pmd-avatar pmd-avatar-dark pmd-avatar-xl d-inline-flex"
                    aria-hidden="true">
                    <span class="material-icons">delete</span>
                </div>
                <h4 class="h5">
                    Delete all products?
                </h4>
                <p>This will delete all products from all pages. This action can not be undone.<br /> Do you still want
                    to continue?</p>
            </div>
            <!-- Modal Footer -->
            <div class="modal-footer justify-content-center mt-2">
                <button aria-label="Close"
                    (click)="deleteAllProducts.hide(); context.deleteAllProductsFromInvoice();"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    pmdRipple>
                    Yes
                </button>
                <button aria-label="Close"
                    (click)="deleteAllProducts.hide()"
                    pmdRipple
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="light">
                    No
                </button>
            </div>
        </div>
    </div>
</div>
<!-- /END/ delete all products -->

<!-- Admin Alert Message Modal -->
<div *ngIf="isAdmin"
    pmdModal
    modalTrap
    #adminAlertModal="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    [config]="{backdrop: 'static', keyboard: true}"
    aria-labelledby="adminAlertLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header m-0 position-absolute end-0"
                style="z-index: 9999;">
                <button aria-hidden="true"
                    aria-label="Close"
                    (click)="context.closeAdminAlert()"
                    class="ms-auto close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <div class="mb-3 pmd-avatar pmd-avatar-warning pmd-avatar-xl d-inline-flex"
                        aria-hidden="true">
                        <span class="material-icons">security</span>
                    </div>
                </div>
                <h4 id="adminAlertLabel"
                    class="h5 text-center">
                    Admin Message
                </h4>
                <div class="text-left"
                    [innerHTML]="context.invoice?.alertMessage | safeHtml"></div>
            </div>
            <div class="modal-footer justify-content-center mt-2">
                <button type="button"
                    aria-label="Close"
                    (click)="context.closeAdminAlert()"
                    pmdRipple
                    pmd-btn-raised
                    color="secondary">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>